import {Model} from "vue-mc";
import {
  length,
  required,
  string,
  url,
  date,
  after,
} from "vue-mc/validation";

export class News extends Model
{
  static STATUS = {
    SCHEDULED: 'scheduled',
    PUBLISHED:'published',
    DISABLED: 'disabled',
  }

  defaults() {
    return {
      id: null,
      name: null,
      status: null,
      publishedAt: null,
      videoLink: null,
      externalLink: null,
      isAction: false,
      categories: [],
      content: null,
    }
  }

  validation() {
    return {
      name: [required, string, length(3, 255)],
      content: [required],
      publishedAt: [required, date, after(new Date())],
      videoLink: [url],
      externalLink: [url],
      categories: [required],
    }
  }

  options() {
    return {
      validateOnChange: true,
    }
  }
}
